import { render } from "./CgBarChart.vue?vue&type=template&id=a3ce2976"
import script from "./CgBarChart.vue?vue&type=script&lang=js"
export * from "./CgBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__